import { OrderView, OrdersService } from "@/api";
import { useEffect, useState } from "react";

export function useOrderView(orderId?: number) {
  const [data, setData] = useState<OrderView | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    // only fetch if orderId is defined
    if (orderId === undefined) {
      return;
    }

    let cancelled = false;

    async function fetchInvoiceView() {
      try {
        setIsLoading(true);
        setError(null);

        // cast orderId to number since we already checked it's not undefined
        const response = await OrdersService.getOrderInvoiceViewOrdersTaxinvoiceOrderIdGet(orderId as number);

        if (!cancelled) {
          setData(response);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error("Unknown error"));
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }

    fetchInvoiceView();

    return () => {
      cancelled = true;
    };
  }, [orderId]);

  return { data, isLoading, error };
}
